module.exports = __webpack_public_path__ + "img/threshold_select.0a74e51e.png";